var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row table-wrapper" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isGenerating,
            expression: "isGenerating"
          }
        ]
      },
      [_c("ring-loader")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isEnd && _vm.mealsToRender.length <= 0,
            expression: "isEnd && mealsToRender.length <= 0"
          }
        ],
        staticStyle: {
          "margin-top": "20px",
          "padding-left": "20px",
          "font-weight": "bold"
        }
      },
      [_vm._v("\n        BRAK ZAPLANOWANYCH POSIŁKÓW W TYM ZAKRESIE DAT\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isEnd && _vm.mealsToRender.length > 0,
            expression: "!isEnd && mealsToRender.length > 0"
          }
        ],
        staticClass: "progress",
        staticStyle: { margin: "20px 0" }
      },
      [
        _c(
          "div",
          {
            staticClass: "progress-bar",
            style: { width: _vm.currentProgress + "%" },
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.currentProgress,
              "aria-valuemin": "0",
              "aria-valuemax": _vm.length
            }
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.currentProgress) + "% Complete")
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isEnd && _vm.mealsToRender.length > 0 && !_vm.isGenerating,
            expression: "isEnd && mealsToRender.length > 0 && !isGenerating"
          }
        ],
        attrs: { id: "table" }
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.mealsToRender, function(record, index) {
            return _c("tr", { key: index }, [
              _c("td", [_vm._v(_vm._s(record.serving.meal.id))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.serving.meal.name))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.variant.name))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.basketMeal.size.name))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.serving.meal.rateCount))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n                  " +
                    _vm._s(
                      record.serving.meal.rateCount == 0
                        ? 0
                        : (
                            record.serving.meal.rateSum /
                            record.serving.meal.rateCount
                          ).toFixed(2)
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("last-three-months-rating", {
                    attrs: { "meal-id": record.serving.meal.id }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("rate-for-month", {
                    attrs: {
                      count: false,
                      month: _vm.getMonth(0),
                      year: _vm.getYear(0),
                      "meal-id": record.serving.meal.id,
                      index: index
                    },
                    on: { loadingFinished: _vm.finishedLoading }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("rate-for-month", {
                    attrs: {
                      count: true,
                      month: _vm.getMonth(0),
                      year: _vm.getYear(0),
                      "meal-id": record.serving.meal.id,
                      index: index
                    },
                    on: { loadingFinished: _vm.finishedLoading }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("rate-for-month", {
                    attrs: {
                      count: false,
                      month: _vm.getMonth(1),
                      year: _vm.getYear(1),
                      "meal-id": record.serving.meal.id,
                      index: index
                    },
                    on: { loadingFinished: _vm.finishedLoading }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("rate-for-month", {
                    attrs: {
                      count: true,
                      month: _vm.getMonth(1),
                      year: _vm.getYear(1),
                      "meal-id": record.serving.meal.id,
                      index: index
                    },
                    on: { loadingFinished: _vm.finishedLoading }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("rate-for-month", {
                    attrs: {
                      count: false,
                      month: _vm.getMonth(2),
                      year: _vm.getYear(2),
                      "meal-id": record.serving.meal.id,
                      index: index
                    },
                    on: { loadingFinished: _vm.finishedLoading }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("rate-for-month", {
                    attrs: {
                      count: true,
                      month: _vm.getMonth(2),
                      year: _vm.getYear(2),
                      "meal-id": record.serving.meal.id,
                      index: index
                    },
                    on: { loadingFinished: _vm.finishedLoading }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("last-year-usage", {
                    attrs: { "meal-id": record.serving.meal.id }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.serving.photos.length))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(_vm.getLastPhoto(record.serving.photos).createdAt)
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.getLastPhoto(record.serving.photos).file
                        ? "https://dccore.ntfy.pl/upload/multimedia/" +
                            _vm.getLastPhoto(record.serving.photos).file
                        : ""
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.serving.stringAllMaterials))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(record.serving.meal.stringAllergens))])
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Id posiłku")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Nazwa posiłku")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Wariant")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Wielkość")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Liczba ocen")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Ocena ogólna")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [
          _vm._v("Ocena z ostatnich 3-ech miesięcy")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Miesiąc zrobienia raportu")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Miesiąc zrobienia raportu -1")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Miesiąc zrobienia raportu -2")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [
          _vm._v("Ile razy posiłek był użyty w ciągu ostatnich 12 m-scy?")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Ile zdjęć na porcji")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Data dodania zdjęcia")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Link do zdjęcia")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Składniki posiłku")]),
        _vm._v(" "),
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Alergeny")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("Średnia ocen")]),
        _vm._v(" "),
        _c("th", [_vm._v("Liczba osób oceniających")]),
        _vm._v(" "),
        _c("th", [_vm._v("Średnia ocen")]),
        _vm._v(" "),
        _c("th", [_vm._v("Liczba osób oceniających")]),
        _vm._v(" "),
        _c("th", [_vm._v("Średnia ocen")]),
        _vm._v(" "),
        _c("th", [_vm._v("Liczba osób oceniających")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe0e5fc4", { render: render, staticRenderFns: staticRenderFns })
  }
}